import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import $ from 'jquery';

import '../src/assets/vendors/mdi/css/materialdesignicons.min.css';
import '../src/assets/vendors/css/vendor.bundle.base.css';
import '../src/assets/css/style.css';

import '../src/assets/vendors/js/vendor.bundle.base.js';
import '../src/assets/js/off-canvas';
import '../src/assets/js/hoverable-collapse';
import '../src/assets/js/misc';
import '../src/assets/js/settings';
import '../src/assets/js/todolist';
import './i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
